import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private title$ = new BehaviorSubject<string>('');

  setTitle(title: string) {
    this.title$.next(title || '');
  }

  get title() {
    return this.title$.asObservable();
  }

}
